var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('luma-button-wrapper',{scopedSlots:_vm._u([{key:"button",fn:function(){return [_c('b-button',{staticClass:"col-12",attrs:{"variant":"primary"},on:{"click":function($event){return _vm.save()}}},[(!_vm.spinner)?_c('h3',[_vm._v(_vm._s(_vm.text ? _vm.text : 'Änderungen speichern'))]):_c('b-spinner')],1)]},proxy:true}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04c3b7b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/luma-save-changes-button.vue
// module id = null
// module chunks = 